import { mapState } from 'vuex'
export default {
  computed:{
    ...mapState({
      isCompany: state => state.auth.isCompany,
      isAdmin: state => state.auth.isAdmin,
      isIndie: state => state.auth.isIndie,
      isSupervisor: state => state.auth.isSupervisor,
      isAC: state => state.auth.isAC,
      isAS: state => state.auth.isAS,
      isACS: state => state.auth.isACS,
      isASS: state => state.auth.isASS,
      isPartner: state => state.auth.isPartner,
      subjectId:state => state.auth.subjectId,
      subject:state => state.auth.subject,
      userinfo: state => state.auth.userinfo
    }),
  }
}